import axios from "axios";
import axiosInstance from "../../axiosinterceptor";
//  const drg_api="/get_drg_code_acs";
const drg_api = "/mutlti_drg_prepare_response";
const validate_api = "/checkIfCodeExists";
const accept_codes_api = "/AcceptOrDeleteCodes";
//  const accept_codes_api = "https://y0kzl1wmr9.execute-api.ap-southeast-2.amazonaws.com/dummy/test-lambda-vignesh"
const reccomendations_api = "/codeRecommendation";
const reference_api = "/acs_download_code_reference";
const remove_codes_api="/SaveUnconfirmedCodes"
const check_hac_api =
  "https://c57pmgaxw1.execute-api.ap-southeast-2.amazonaws.com/check_for_cof_acs_beta";
const auditor_accept_codes_api = "/auditor_screen_edit_acs";
export const calculateDrgCode = async (payload) => {
  return axiosInstance.post(drg_api, payload);
};
export const validateCode = async (code, type, sex) => {
  const checkType =
    type === "additional" || type === "principal" ? "ICD" : "ACHI";
  try {
    const response = await axiosInstance.post(validate_api, {
      u_agey: 22,
      u_aged: 4,
      sex,
      code,
      check_for: checkType,
    });

    if (response.status === 200) {
      return {
        valid: response.data.code_exists,
        description: response.data.description || "",
        isWarning: response.data.is_warning || false,
        warningDescription: response.data.warning_description || "",
        isPopup: response.data.should_popup,
      };
    }
  } catch (error) {
    console.error("Error validating code:", error);
  }
  return {
    valid: false,
    description: "",
    isWarning: false,
    warningDescription: "",
    isPopup: false,
  };
};

export const acceptCode = async (payload) => {
  const apiURL =accept_codes_api;

  const sortAdditionalCodes = (list = []) => {
    return [...list].sort((a, b) => {
      const aZero = a.startsWith("0");
      const bZero = b.startsWith("0");

      if (aZero && !bZero) return 1;
      if (!aZero && bZero) return -1;
      return 0;
    });
  };

  const orderedPayload = {
    ...payload,
    additional_diagnoses_code: sortAdditionalCodes(
      payload.additional_diagnoses_code ?? []
    ),
  };
  console.log(payload, "payload", orderedPayload);

  try {
    const response = await axiosInstance.post(accept_codes_api, orderedPayload);
    return response;
  } catch (error) {
    console.error("Error submitting diagnosis:", error);
    throw error;
  }
};
export const removeCode = async (payload) => {
  const apiURL =remove_codes_api;

  try {
    const response = await axiosInstance.post(apiURL, payload);
    return response.status === 200;
  } catch (error) {
    console.error("Error submitting diagnosis:", error);
    return false;
  }
};
export const auditorAcceptCode = async (payload) => {
  try {
    const response = await axiosInstance.post(accept_codes_api, payload);
    return response.status === 200;
  } catch (error) {
    console.error("Error submitting diagnosis:", error);
    return false;
  }
};
export const codeReccomendations = async (payload, signal) => {
  try {
    const response = await axiosInstance.post(reccomendations_api, payload, {
      signal, // Attach AbortController signal to cancel previous requests
    });
    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("Request canceled:", error.message);
    } else {
      console.error("Error fetching recommendations:", error);
    }
    return false;
  }
};
export const codeReferenceClick = async (code, reasoningId) => {
  // console.log('callhapp');

  // const url = `https://uuzzqsxaj6.execute-api.ap-southeast-2.amazonaws.com/acs_download_code_reference/?code=${code}`;
  const params = {
    codes: code,
    reasoning_id: reasoningId,
  };
  try {
    const response = await axiosInstance.get(reference_api, { params });
    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("Request canceled:", error.message);
    } else {
      console.error("Error fetching recommendations:", error);
    }
    return false;
  }
};
export const checkHAC = async (code) => {
  const url = `/checkForCofAcs/?code=${code}`;
  try {
    const response = await axiosInstance.get(url);
    // console.log(response.status,'checkq');
    return response;
  } catch (error) {
    // console.log(error,'yy');

    if (axios.isCancel(error)) {
      console.log("Request canceled:", error.message);
    } else {
      console.error("Error fetching recommendations:", error);
    }
    return false;
  }
};
export const viewEmrDmrPas = async (last_hcp_line_id) => {
  const url =
    "/view_dmr_emr_pas_scanned";
  const payload = {
    
      // patient_mrn: patientMRN,
      // episode_id: episodeID,
      hcp_line_id:last_hcp_line_id
  
  };
  try {
    const response = await axiosInstance.post(url, payload);
    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("Request canceled:", error.message);
    } else {
      console.error("Error fetching recommendations:", error);
    }
  }
};
